import React, {useState} from 'react';
import {useIntl} from 'react-intl';


import * as feedbackFormConstants from './feedbackFormConstants';

import feedbackService from '../../../../services/FeedbackService';

import {CaptchaButton, ConfirmationButton} from '../../Button';
import {FormActions, FormFieldError, FormPage, Textarea, ValidatingForm} from '../../Form';
import {useIsAuthenticated} from '../../../contexts/Auth';

import styles from './FeedbackForm.scss';
import PropTypes from 'prop-types';


function FeedbackForm({onSubmitted}) {

    const isAuthenticated = useIsAuthenticated();
    const isCaptchaForm = !isAuthenticated;
    const {formatMessage} = useIntl();

    const [isSubmitting, setIsSubmitting] = useState(false);

    const doSubmit = formData => {

        setIsSubmitting(true);

        (async () => {

            if (isAuthenticated) {
                await feedbackService.submitUserFeedback(formData);
            } else {
                await feedbackService.submitGuestFeedback(formData);
            }

            onSubmitted();
        })();
    };

    return (
        <ValidatingForm
            id={'feedback.form'}
            isCaptcha={isCaptchaForm}
            validationSchema={feedbackFormConstants.SCHEMA_FEEDBACK_FORM}
        >
            {({form}) => (
                <FormPage className={styles.feedbackForm}>

                    <Textarea
                        id={'feedbackText'}
                        isDisabled={isSubmitting || (isCaptchaForm && form.isCaptchaRunning())}
                        maxLength={feedbackFormConstants.TEXT_LENGTH_MAX}
                        name={'text'}
                        placeholder={formatMessage({id: 'feedback.form.field.text.placeholder'})}
                        onChange={text => form.setData({text})}
                        value={form.getData('text')}
                    />
                    <FormFieldError error={form.getCurrentError('text')}/>

                    {!isSubmitting && (
                        <FormActions cssClass={styles.formActions}>
                            <>
                                {isAuthenticated && (
                                    <ConfirmationButton
                                        isDisabled={form.hasErrors()}
                                        labelI18n={'feedback.form.button.label'}
                                        onClick={() => doSubmit(form.getData())}
                                    />
                                )}

                                {isCaptchaForm && (
                                    <CaptchaButton
                                        form={form}
                                        labelI18n={'feedback.form.button.label'}
                                        onClick={() => doSubmit(form.getData())}
                                    />
                                )}
                            </>
                        </FormActions>
                    )}

                </FormPage>
            )}

        </ValidatingForm>
    );
}


FeedbackForm.propTypes = {
    onSubmitted: PropTypes.func
};

FeedbackForm.defaultProps = {};


export default FeedbackForm;
